var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_489",
    "data-name": "Grupo 489",
    transform: "translate(-1563 -1426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_100",
    "data-name": "Rect\\xE1ngulo 100",
    width: 26,
    height: 26,
    transform: "translate(1589 1452) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght300_GRAD0_opsz40",
    d: "M355.118-690.525l-4.776-4.783a.634.634,0,0,1-.2-.483.667.667,0,0,1,.214-.486.676.676,0,0,1,.494-.21.676.676,0,0,1,.494.21l5.147,5.147a.9.9,0,0,1,.2.282.821.821,0,0,1,.062.323.829.829,0,0,1-.062.319.885.885,0,0,1-.2.286l-5.159,5.159a.657.657,0,0,1-.483.2.677.677,0,0,1-.494-.21.676.676,0,0,1-.21-.494.676.676,0,0,1,.21-.494Z",
    transform: "translate(2266.563 1792.139) rotate(-90)",
    fill: "#00bdd9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b985dd0c73e9608e5421c14e87aefce8.svg";
export { ForwardRef as ReactComponent };